export default "__VITE_ASSET__OlP$sAnC__"